<template>
  <div
    v-if="!isStoreBaseEnabled"
    class="container"
  >
    <Step />
    <form @submit.prevent="onNextStep">
      <section>
        <div class="header">
          Ürün Adını Giriniz
        </div>
        <div class="row">
          <label class="label">
            ÜRÜN ADI
            <span class="required">*</span>
          </label>
          <div>
            <input
              type="text"
              class="form-control"
              :class="{'is-invalid' : errors.has('productName')}"
              v-model="formData.productName"
              name="productName"
              v-validate="'required'"
              data-vv-as="Ürün Adı"
              placeholder="Örnek: Arçelik TKM 9961 B Telve Türk Kahve Makinesi 0-0-TKM9961B"
              autocomplete="off"
              v-readonly
            >
            <div class="invalid-feedback">
              {{ errors.first('productName') }}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="header">
          Ürün Kategorisini Seçiniz
        </div>
        <div class="row">
          <label class="label">
            KATEGORİ SEÇİNİZ
            <span class="required">*</span>
          </label>
          <CategoryTree
            v-model="formData.productCategory"
            name="productCategory"
            :options="getCategories"
            v-validate="'requiredSelect'"
            data-vv-as="Kategori"
            @onSelect="onSelect"
            :class="{'is-invalid' : errors.has('productCategory')}"
            v-readonly
          />
          <div class="invalid-feedback">
            {{ errors.first('productCategory') }}
          </div>
        </div>
      </section>
      <section>
        <div class="header">
          Ürün Bilgilerini Giriniz
        </div>
        <div class="row">
          <label class="label">
            MODEL KODU
            <span class="required">*</span>
          </label>
          <div>
            <input
              type="text"
              class="form-control"
              v-model="formData.productModelCode"
              name="productModelCode"
              v-validate="'required'"
              data-vv-as="Model Kodu"
              autocomplete="off"
              :class="{'is-invalid' : errors.has('productModelCode')}"
              v-readonly
            >
            <div class="invalid-feedback">
              {{ errors.first('productModelCode') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="label">
            MARKA
            <span class="required">*</span>
          </label>
          <div>
            <BrandSelect
              v-model="formData.productBrand"
              v-validate="'requiredSelect'"
              data-vv-as="Marka"
              name="productBrand"
              :class="{'is-invalid' : errors.has('productBrand')}"
              v-readonly
            />
            <div class="invalid-feedback">
              {{ errors.first('productBrand') }}
            </div>
          </div>
        </div>
        <template v-if="getSlicers.length > 0">
          <div
            class="row"
            v-for="(slicer, i) in getSlicers"
            :key="i"
          >
            <label class="label">
              {{ slicer.name }}
              <span
                class="required"
                v-if="slicer.validation.required"
              >
                *
              </span>
            </label>
            <div>
              <DynamicInput
                :attr="slicer"
                :class="{'is-invalid' : errors.has(slicer.props.name), 'form-control': slicer.className}"
                v-validate="slicer.validation"
                data-vv-validate-on="change|input"
                v-model="formData.productSlicers[slicer.id]"
                v-readonly
              />
              <div class="invalid-feedback">
                {{ errors.first(slicer.props.name) }}
              </div>
            </div>
          </div>
        </template>
        <div class="row">
          <label class="label">
            ÜRÜN AÇIKLAMASI
            <span class="required">*</span>
          </label>
          <div>
            <textarea
              class="form-control"
              v-model="formData.productDescription"
              v-validate="'required'"
              name="productDescription"
              data-vv-as="Ürün Açıklaması"
              :class="{'is-invalid' : errors.has('productDescription')}"
            />
            <div class="invalid-feedback">
              {{ errors.first('productDescription') }}
            </div>
          </div>
        </div>
      </section>
      <div class="button-wrapper">
        <button
          type="submit"
          class="btn btn-trendyol"
        >
          DEVAM ET
        </button>
      </div>
    </form>
  </div>
  <div v-else>
    Trendyol pazaryeri satıcısı olmadığınız için bu sayfayı görme yetkiniz bulunmamaktadır.
  </div>
</template>

<script>
import Step from './Components/Step';
import DynamicInput from './Components/DynamicInput';
import CategoryTree from '@/components/CategoryTree/Index';
import BrandSelect from '@/components/BrandSelect/Index';

import { mapActions, mapGetters } from 'vuex';
import spinner from '@/utils/spinner';

export default {
  name: 'ProductInfo',
  components: {
    BrandSelect,
    CategoryTree,
    Step,
    DynamicInput,
  },
  data () {
    return {
      formData: {},
    };
  },
  computed: {
    ...mapGetters({
      getFormData: 'singleProduct/getFormData',
      getCategories: 'singleProduct/getCategories',
      getSlicers: 'singleProduct/getSlicers',
    }),
    isStoreBaseEnabled () {
      return this.$route.query?.storeBaseEnabled;
    },
  },
  methods: {
    ...mapActions({
      setFormData: 'singleProduct/setFormData',
      getProductCategories: 'singleProduct/getProductCategories',
      getSelectedCategoryAttributes: 'singleProduct/getSelectedCategoryAttributes',
    }),
    async onSelect (category) {
      await this.getSelectedCategoryAttributes(category.Id);
    },
    async validate () {
      const result = await this.$validator.validateAll();
      if (result) {
        this.setFormData(this.formData);
        return true;
      }
      return false;
    },
    async onNextStep () {
      const isValid = await this.validate();
      if (isValid) {
        this.$router.push({ name: 'ProductSaleInfo' });
        this.$root.trackEvent({
          eventCategory: 'MobileAppListing',
          eventAction: 'ÜrünListesiDropdownMenüAçanlar',
          eventLabel: 'ÜrünListesiDropdownMenüTekilÜrünEkleme1.adim',
        });
      }
    },
  },
  async created () {
    spinner.start();
    await this.getProductCategories();
    this.formData = this.getFormData;
    this.$emit('onStartEvent');
    spinner.done();
  },
};
</script>
